import type { LucideIcon } from 'lucide-react';

import styles from './kit.module.scss';

export type StatusTone = 'blue' | 'green' | 'amber' | 'orange' | 'rose' | 'slate';

const TONE: Record<StatusTone, string> = {
  blue: styles.statusBlue,
  green: styles.statusGreen,
  amber: styles.statusAmber,
  orange: styles.statusOrange,
  rose: styles.statusRose,
  slate: styles.statusSlate,
};

export function StatusMark({
  label,
  word,
  tone,
  icon: Icon,
}: {
  label: string;
  word: string;
  tone: StatusTone;
  icon: LucideIcon;
}) {
  return (
    <span className={`${styles.statusMark} ${TONE[tone]}`} title={label} aria-label={label}>
      <Icon size={16} strokeWidth={2} aria-hidden />
      <span className={styles.statusWord}>{word}</span>
    </span>
  );
}
